import { Box, Typography } from "@mui/material";
import useColors from "../../../../../../../api/hooks/useColors";

const OSVersionManagementChartLegend = () => {
  const colors = useColors();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          color: colors.text_secondary,
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 1,
            width: "10px",
            height: "10px",
            background: colors.light_green,
            borderRadius: "3px",
          }}
        />
        <Typography variant="caption">Running Latest OS</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          color: colors.text_secondary,
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 1,
            width: "10px",
            height: "10px",
            background: colors.red,
            borderRadius: "3px",
          }}
        />
        <Typography variant="caption">Running Older OS</Typography>
      </Box>
    </Box>
  );
};

export default OSVersionManagementChartLegend;
